import { render, staticRenderFns } from "./BridgeTokenAccountBalance.vue?vue&type=template&id=4995ba10"
import script from "./BridgeTokenAccountBalance.vue?vue&type=script&lang=ts"
export * from "./BridgeTokenAccountBalance.vue?vue&type=script&lang=ts"
import style0 from "./BridgeTokenAccountBalance.vue?vue&type=style&index=0&id=4995ba10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports